import styles from './DialogImageTitle.module.scss';
import React from 'react';
import clsx from 'clsx';
import { useDialogContext } from '../DialogContext.ts';
import { Image } from '../../Image/Image.tsx';
export function DialogImageTitle({ image, children, imageClassName }) {
    const { imageTitleSize } = useDialogContext();
    return /*#__PURE__*/ React.createElement("span", {
        className: clsx(styles.imageTitle, styles[imageTitleSize])
    }, /*#__PURE__*/ React.createElement(Image, {
        image: image,
        className: clsx(styles.image, imageClassName)
    }), children);
}
